<template>
  <main class="app-main">
    <div class="app-content-header">
      <div class="container-fluid">
        <div class="row">
          <div class="col-sm-6"><h3 class="mb-0">إضافة حجز عقار</h3></div>
          <div class="col-sm-6">
            <ol class="breadcrumb float-sm-end">
              <li class="breadcrumb-item"><router-link to="/">الرئيسية</router-link></li>
              <li class="breadcrumb-item"><router-link to="/booking">حجز العقارات</router-link></li>
              <li class="breadcrumb-item active">إضافة حجز</li>
            </ol>
          </div>
        </div>
      </div>
    </div>

    <div class="app-content">
      <div class="container-fluid">
        <div class="row justify-content-center">
          <div class="col-12 col-sm-10">
            <div class="card card-secondary card-outline mb-4 mt-4">
              <div class="card-header"><div class="card-title">إضافة حجز عقار</div></div>
              <errorAlert v-if="hasError" :alertMessage="message" :errorNumber="errorNumber" />
              <successAlert v-if="hasSuccess" :message="message" />

              <form @submit.prevent="submitData()">
                <div class="card-body">
                  <div class="row">
                    <div class="col-12 col-sm-6 mb-3">
                      <label class="form-label">جوال العميل: <span class="req">*</span></label>
                      <input type="text" class="form-control" placeholder="جوال العميل المسجل" @keyup="getClientData()" v-model="userMobile">
                    </div>
                    <div class="col-12 col-sm-6 mb-3">
                      <loader v-if="userLoader" />
                      <div v-if="userName">
                        <label class="form-label">اسم العميل:</label>
                        <div class="fw-bold">{{ userName }}</div>
                      </div>
                    </div>
                  </div>

                  <div class="row">
                    <div class="col-12 col-sm-6 mb-3">
                      <label class="form-label">الاسم الكامل: <span class="req">*</span></label>
                      <input type="text" class="form-control" v-model="fullName">
                    </div>
                    <div class="col-12 col-sm-6 mb-3">
                      <label class="form-label">رقم الجوال: <span class="req">*</span></label>
                      <input type="text" class="form-control" v-model="mobile" maxlength="10">
                    </div>
                  </div>

                  <div class="row">
                    <div class="col-12 col-sm-6 mb-3">
                      <label class="form-label">العقار: <span class="req">*</span></label>
                      <input type="text" class="form-control" placeholder="ابحث برقم أو اسم العقار" v-model="propertySearch" @keyup="searchProperty()">
                      <div v-if="propertiesList.length" class="list-group mt-1 shadow-sm" style="max-height:180px;overflow-y:auto;position:absolute;z-index:999;width:calc(100% - 24px)">
                        <button v-for="p in propertiesList" :key="p.id" type="button"
                          class="list-group-item list-group-item-action text-start"
                          @click="selectProperty(p)">
                          #{{ p.id }} - {{ p.title }}
                        </button>
                      </div>
                      <div v-if="selectedProperty" class="mt-2">
                        <span class="badge bg-success">#{{ selectedProperty.id }} - {{ selectedProperty.title }}</span>
                      </div>
                    </div>
                    <div class="col-12 col-sm-6 mb-3">
                      <label class="form-label">الراتب (ر.س):</label>
                      <input type="number" class="form-control" v-model="salary" min="0">
                    </div>
                  </div>

                  <div class="row">
                    <div class="col-12 col-sm-6 mb-3">
                      <label class="form-label">الالتزامات:</label>
                      <input type="text" class="form-control" v-model="obligations" placeholder="وصف الالتزامات...">
                    </div>
                    <div class="col-12 col-sm-6 mb-3">
                      <label class="form-label">يشمل طلب تمويل؟</label>
                      <div class="mt-2">
                        <div class="form-check form-check-inline">
                          <input class="form-check-input" type="radio" v-model="financingRequest" :value="true" id="finYes">
                          <label class="form-check-label" for="finYes">نعم</label>
                        </div>
                        <div class="form-check form-check-inline">
                          <input class="form-check-input" type="radio" v-model="financingRequest" :value="false" id="finNo">
                          <label class="form-check-label" for="finNo">لا</label>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="row">
                    <div class="col-12 mb-3">
                      <label class="form-label">ملاحظات الإدارة:</label>
                      <textarea class="form-control" rows="2" v-model="adminNotice" placeholder="ملاحظات..."></textarea>
                    </div>
                  </div>

                  <div class="alert alert-info">
                    <i class="bi bi-info-circle me-1"></i>
                    سيتم إضافة الحجز بحالة "غير مدفوع" ويمكن تعديلها لاحقاً.
                  </div>
                </div>

                <div class="card-footer">
                  <div class="row">
                    <div class="col text-end">
                      <button v-if="!formLoader" type="submit" class="btn btn-success">إضافة</button>
                      <loader v-if="formLoader" />
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </main>
</template>

<script>
import { toast } from '@/helpers/tools';

export default {
  name: 'BookingCreate',
  data(){
    return {
      formLoader: false,
      hasError: false,
      hasSuccess: false,
      message: '',
      errorNumber: 0,

      userMobile: null,
      userId: null,
      userName: null,
      userLoader: false,

      fullName: null,
      mobile: null,
      salary: null,
      obligations: null,
      financingRequest: false,
      adminNotice: null,

      propertySearch: '',
      propertiesList: [],
      selectedProperty: null,
      propertyId: null,

      searchTimer: null,
    }
  },
  methods: {
    getClientData(){
      if(this.userMobile && this.userMobile.length >= 10){
        this.hasError = false;
        this.userLoader = true;
        this.userId = null;
        this.userName = null;
        this.$http.post('/api/admin/properties/getUser', {
          mobile: this.userMobile.trim(),
        }).then(({data}) => {
          this.userId = data.user.id;
          this.userName = data.user.name;
          if(!this.fullName) this.fullName = data.user.name;
          if(!this.mobile) this.mobile = data.user.mobile;
          this.userLoader = false;
        }).catch(err => {
          [this.message, this.errorNumber] = this.$globalError(err, true);
          this.hasError = true;
          this.userLoader = false;
          window.scrollTo({ top: 0, behavior: 'smooth' });
        });
      }
    },
    searchProperty(){
      clearTimeout(this.searchTimer);
      if(!this.propertySearch || this.propertySearch.length < 2){
        this.propertiesList = [];
        return;
      }
      this.searchTimer = setTimeout(() => {
        this.$http.get(`/api/admin/properties/list?name=${encodeURIComponent(this.propertySearch)}&limit=10`).then(({data}) => {
          this.propertiesList = data.properties ?? [];
        });
      }, 400);
    },
    selectProperty(p){
      this.selectedProperty = p;
      this.propertyId = p.id;
      this.propertySearch = '';
      this.propertiesList = [];
    },
    submitData(){
      this.hasError = false;
      this.hasSuccess = false;

      if(!this.userId){
        this.message = 'يجب تحديد العميل عن طريق رقم الجوال أولاً';
        this.errorNumber = 0;
        this.hasError = true;
        window.scrollTo({ top: 0, behavior: 'smooth' });
        return;
      }
      if(!this.propertyId){
        this.message = 'يجب اختيار العقار المراد حجزه';
        this.errorNumber = 0;
        this.hasError = true;
        window.scrollTo({ top: 0, behavior: 'smooth' });
        return;
      }
      if(!this.fullName || !this.mobile){
        this.message = 'يرجى تعبئة الاسم الكامل ورقم الجوال';
        this.errorNumber = 0;
        this.hasError = true;
        window.scrollTo({ top: 0, behavior: 'smooth' });
        return;
      }

      this.formLoader = true;
      this.$http.post('/api/admin/propReservation/create', {
        userId: this.userId,
        propertyId: this.propertyId,
        fullName: this.fullName,
        mobile: this.mobile,
        salary: this.salary ? parseFloat(this.salary) : 0,
        obligations: this.obligations,
        financingRequest: this.financingRequest,
        adminNotice: this.adminNotice,
      }).then(({data}) => {
        toast('تم إضافة الحجز بنجاح', 'success');
        this.$router.push(`/booking/update/${data.row.id}`).catch(() => {});
        this.formLoader = false;
      }).catch(err => {
        [this.message, this.errorNumber] = this.$globalError(err, true);
        this.hasError = true;
        window.scrollTo({ top: 0, behavior: 'smooth' });
        this.formLoader = false;
      });
    },
  },
}
</script>